// extracted by mini-css-extract-plugin
export default {"HotspotTable":"styles_HotspotTable__alLca"};